/**
 * Notification Context
 *
 * Re-exports notification context from @redfoxwp/core-components.
 *
 * @since 1.0.0
 */

export type {
	Notification,
	NotificationContextValue,
	NotificationType,
} from '@redfoxwp/core-components/contexts/notification-context';
export {
	NotificationContext,
	NotificationProvider,
	useNotification,
} from '@redfoxwp/core-components/contexts/notification-context';

